// -------------------销售----------
// 合同状态
export const contractStates = [
  { label: '履行中', value: 4 },
  { label: '已履行', value: 5 }
]
export const contractState = [
  { label: '履行中', value: 3 },
  { label: '已履行', value: 4 }
]
// -----------------采购------------
// -----------------财务------------
// -----------------仓储------------
// -----------------CRM-------------
